<template>
  <div style="padding-bottom: 2%;">
     <div class="col-12 col-md-9" style="padding-bottom: 2%;">
       <div style="width: 50%; margin-left: 3%;">
         <a href="#" @click="back">
           <u> Account Statements </u>
         </a> &nbsp > &nbsp Site Checkout
       </div>
      <div class="invoiceBox">
            <strong class="m-l-4" style="margin-top: 4%; display: block; font-size: 18px;">
              Title of Invoice 2018
            </strong>
            <strong class="m-l-4" style="font-size: 28px; display: block; margin-top: 1%;">$2,187.00</strong>
          <p class="m-l-4" style="font-size: 14px;">Due January 1, 2019</p>
        <div class="m-l-4" style="border: 0.5px solid rgb(89, 149, 247); width: 90%;">

        </div>
        <div style="margin-top: 2%;">
          <div class="col-11 col-md-8 m-l-3" v-for="(item, index) in itemsList">
            {{itemsList[index].name}} ...................................${{itemsList[index].cost}}
          </div>
          <strong class="col-11 col-md-8 m-l-3">Total...................................$2,187.00</strong>
          <p style="margin-top: 1%; font-size: 13px; width: 75%;" class="m-l-4">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent justo sapien, posuere at bibendum ut, mattis at mauris. Quisque varius hendrerit lacinia. Nullam quis consequat tortor, consequat dapibus dolor. Vivamus aliquet porttitor imperdiet. Curabitur eﬃcitur hendrerit lorem. Duis posuere dignissim ipsum, sit amet aliquam justo rutrum in.
          </p>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-3" style="margin-top: 5%;">
      <button class="btn btn-success eDetailElement" style="margin-left: 5%; margin-bottom: 5%;" @click="goToType()">
        Proceed to Checkout
      </button>
      <button class="btn eDetailElement" style="margin-left: 5%" @click="back">
        Back to Invoices
      </button>
    </div>
  </div>
</template>

<script>
import { getSiteInvoices } from '~/js/FormFunctions';
import BaseSelect from '@/components/BaseSelect';
import moment from 'moment';

const sumReducer = (accumulator, currentValue) => accumulator + currentValue;

export default {
  name: 'InvoiceCheckoutType',
  props: ['siteNumber'],
  components: { BaseSelect },

  data() {
    return {
      isValidNum: false,
      fetchingData: false,
      name: '2018 Invoice',
      showModal: false,
      yearFilter: null,
      years: [{ value: null, text: '' },
        { value: '2016', text: '2016' },
        { value: '2017', text: '2017' },
        { value: '2018', text: '2018' }],
      itemsList: [{ name: 'item1', cost: '1200' },
        { name: 'item2', cost: '1200' },
        { name: 'item3', cost: '1200' },
        { name: 'item4', cost: '1200' },
        { name: 'item5', cost: '1200' },
        { name: 'item6', cost: '1200' }],
      statementTypeFilter: null,
      currInvoiceList: null,
      searchList: null,
      page: 0,
      pages: 0,
    };
  },
  beforeMount() {

  },
  mounted() {
    const vm = this;
    this.fetchingData = true;
    getSiteInvoices(this.siteNumber)
      .then((data) => {
        vm.fetchingData = false;
        vm.invoices = data;
      })
      .catch(() => {
        vm.fetchingData = false;
      });
  },
  methods: {
    payFromList(index) {

    },
    calcPages() {
      if (this.searchList.length <= 3) {
        if (this.searchList.length == 0) {
          this.pages = 0;
        } else {
          this.pages = 1;
        }
      } else if (this.searchList.length % 3 != 0) {
        this.pages = parseInt(this.searchList.length / 3) + 1;
      } else {
        this.pages = this.searchList.length / 3;
      }
    },
    changePage(index) {
      this.currInvoiceList = this.searchList.slice(index * 3, (index * 3) + 3);
    },
    search() {
      if ((this.yearFilter == null || this.yearFilter == '') && (this.statementTypeFilter == null || this.statementTypeFilter == '')) {
        this.searchList = this.invoiceList;
      } else if ((this.yearFilter != null || this.yearFilter != '') && (this.statementTypeFilter == null || this.statementTypeFilter == '')) {
        this.searchList = this.invoiceList.filter(x => x.year == this.yearFilter);
      } else if ((this.yearFilter == null || this.yearFilter == '') && (this.statementTypeFilter != null || this.statementTypeFilter != '')) {
        this.searchList = this.invoiceList.filter(x => x.year == this.statementTypeFilter);
      } else if ((this.yearFilter != null || this.yearFilter != '') && (this.statementTypeFilter != null || this.statementTypeFilter != '')) {
        this.searchList = this.invoiceList.filter(x => x.year == this.yearFilter && x.type == this.statementTypeFilter);
      }
      this.calcPages();
      this.changePage(0);
    },
    back() {
      this.$router.push({ name: 'SiteInvoices', query: this.$route.query });
    },
    goToType() {
      this.$router.push({ name: 'InvoiceCheckoutType', query: this.$route.query });
    },
  },
  computed: {
    totalAmount() {
      if (this.invoices.length === 0) {
        return 0;
      }
      return this.invoices.map(i => i.invoiceAmount).reduce(sumReducer);
    },
  },
};

</script>
